import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import ModalCatalogs, { DeleteCatalogs } from '@/components/ModalCatalogs';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCatalogs } from '@/redux/slices/catalogs/catalogsSlices';
import { fetchAllCompany } from '@/redux/slices/company/companySlices';
import { selectUserData } from '@reduxSlices/user/userSlices';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import './styles.scss';

const Catalogs = () => {
  const dispatch = useDispatch();
  const [selectType, setSelectType] = useState({ name: 'Склади', code: 'storages' });
  const [visibleAddCatalogs, setVisibleAddCatalogs] = useState(false);
  const [catalogsData, setCatalogsData] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window?.innerWidth);
  const { items = [], counts, status, error } = useSelector((state) => state.catalogs) ?? {};
  const { role } = useSelector(selectUserData) ?? {};
  const { allCompany } = useSelector((state) => state.company);
  const [paginationParams, setPaginationParams] = useState({ limit: 10, offset: 0 });
  const toast = useRef(null);
  const type = selectType?.code;
  const formatedItems = items.map(({ fields, ...props }) => ({ ...props, ...fields }));

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const BodyTemplate = (rowData) => {
    const [visible, setVisible] = useState(false);
    return (
      <div className='card flex justify-content-start'>
        <Button
          type='button'
          icon='pi pi-pencil'
          rounded
          style={{ marginRight: '8px' }}
          onClick={() => editRow(rowData)}
        />

        <DeleteCatalogs
          visible={visible}
          open={() => {
            setVisible(true);
          }}
          hide={() => {
            setVisible(false);
          }}
          catalogsData={rowData}
          updateLoad={updateLoad({ ...paginationParams, type })}
        />
      </div>
    );
  };

  const updateLoad = (params) => () => {
    setPaginationParams(params);
    dispatch(fetchCatalogs(params));
  };

  const editRow = (rowData) => {
    setCatalogsData(rowData);
    setVisibleAddCatalogs(true);
  };

  const cols = {
    carriers: [
      { field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'fullName', header: 'Повна назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'ipn', header: 'ІПН/Платник ПДВ', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'edrpou', header: 'Код ЄДРПОУ', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'address', header: 'Адреса', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      {
        field: 'contactName',
        header: 'Контактна особа',
        style: { maxWidth: '320px', minWidth: '200px' },
        sortable: true,
      },
      { field: 'phone', header: 'Номер телефону', style: { maxWidth: '320px', minWidth: '200px' } },
      { field: 'email', header: 'Е-mail', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
    ],
    grade: [{ field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true }],
    products: [
      { field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'certificate', header: 'Сертрифікат', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'unit', header: 'Одиниця виміру', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'length', header: 'Довжина', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'height', header: 'Висота', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'width', header: 'Ширина', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'volume', header: 'Об`єм', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'mass', header: 'Маса', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'codeUKTZED', header: 'Код УКТ ЗЕД', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'price', header: 'Ціна за одиницю', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
    ],
    gang: [
      { field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      {
        field: 'gangManager',
        header: 'Керівник зміни',
        style: { maxWidth: '320px', minWidth: '200px' },
        sortable: true,
      },
      { field: 'phone', header: 'Номер телефону', style: { maxWidth: '320px', minWidth: '200px' } },
    ],
    storages: [
      { field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'address', header: 'Адреса', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      {
        field: 'contactName',
        header: 'Контактна особа',
        style: { maxWidth: '320px', minWidth: '200px' },
        sortable: true,
      },
      { field: 'phone', header: 'Номер телефону', style: { maxWidth: '320px', minWidth: '200px' } },
    ],
    suppliers: [
      { field: 'name', header: 'Назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'fullName', header: 'Повна назва', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'ipn', header: 'ІПН/Платник ПДВ', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'edrpou', header: 'Код ЄДРПОУ', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'address', header: 'Адреса', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
      { field: 'contactName', header: 'Контактна особа', style: { maxWidth: '320px', minWidth: '200px' } },
      { field: 'phone', header: 'Номер телефону', style: { maxWidth: '320px', minWidth: '200px' } },
      { field: 'email', header: 'Е-mail', style: { maxWidth: '320px', minWidth: '200px' }, sortable: true },
    ],
  };

  const openModalHeader = () => {
    setCatalogsData(null);
    setVisibleAddCatalogs(true);
  };

  const onPageChange = (type) => (e) => {
    const newOffset = e.first;
    updateLoad({ limit: e.rows, offset: newOffset, type })();
  };

  const header = (
    <div className='flex align-items-center justify-content-end gap-3'>
      <div className='flex align-items-center gap-3'>
        <Dropdown
          value={selectType}
          onChange={(e) => setSelectType(e.value)}
          className='catalog__select'
          options={[
            { name: 'Склади', code: 'storages' },
            { name: 'Перевізники', code: 'carriers' },
            { name: 'Продукція', code: 'products' },
            { name: 'Постачальники', code: 'suppliers' },
            { name: 'Сорт', code: 'grade' },
            { name: 'Зміна', code: 'gang' },
          ]}
          optionLabel='name'
        />
        <Button icon='pi pi-plus' onClick={openModalHeader} />
      </div>
    </div>
  );

  const footer = (
    <Paginator
      first={paginationParams.offset}
      rows={paginationParams.limit}
      totalRecords={counts}
      onPageChange={onPageChange(type)}
    />
  );

  useEffect(() => {
    dispatch(fetchCatalogs({ ...paginationParams, type }));
  }, [dispatch, paginationParams, type]);

  useEffect(() => {
    if (status === 'failed') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  }, [error, status]);
  useEffect(() => {
    dispatch(fetchAllCompany());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='page'>
      <h2 className='page__title'>Управління довідниками</h2>
      <DataTable
        value={formatedItems}
        header={header}
        responsiveLayout='scroll'
        scrollable
        scrollHeight='1000px'
        showGridlines
        rows={paginationParams.limit}
        emptyMessage='Поки що немає даних'
      >
        {role === 'admin' && (
          <Column
            field={'company_name'}
            header={'Підриємство'}
            style={{ maxWidth: '320px', minWidth: '250px' }}
            sortable={true}
          />
        )}
        {cols[selectType.code]?.map(({ field, header, ...props }, index) => (
          <Column key={index} field={field} header={header} {...props} />
        ))}
        <Column
          header='Редагування'
          body={BodyTemplate}
          style={{ maxWidth: '160px', minWidth: '140px' }}
          frozen={windowWidth > 600}
          alignFrozen='right'
        ></Column>
      </DataTable>

      <ModalCatalogs
        type={selectType.code}
        visible={visibleAddCatalogs}
        hide={() => setVisibleAddCatalogs(false)}
        updateLoad={updateLoad({ ...paginationParams, type })}
        catalogsData={catalogsData}
        allCompany={allCompany}
      />
      <Toast ref={toast} />
    </div>
  );
};

export default Catalogs;
